import { PortalOrderNode } from '@app/services/api/api.types';

export function getPaidPassengerCount(order: PortalOrderNode) {
  return (order.numberOfAdults || 0) + (order.numberOfChildren || 0);
}

export function getBasicChangeFeeTotal(order: PortalOrderNode | null | undefined) {
  if (!order?.changeFeePerPax) {
    return 0;
  }

  return Number(order.changeFeePerPax) * getPaidPassengerCount(order);
}
